import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 435.468 94.58" {...props}><path data-name="Path 163" d="M55.54 49.1a56.84 56.84 0 0128.173 7.647A90.392 90.392 0 01162.6 10.464c31.392 0 59.163 16.1 75.664 41.052C247.118 21.734 273.681 0 305.878 0c36.222 0 66 27.77 70.029 63.992a65.829 65.829 0 018.854-.8c22.136 0 41.052 12.879 50.711 31.392H0C6.037 68.419 28.575 49.1 55.54 49.1z" /></svg>);